import {
  GetPeersPlaybackControl,
  PlaybackState,
} from 'app/containers/rtc/PeersPlaybackContext';
import { T } from 'app/components/localization';
import React from 'react';
import CallErrorMessage from './CallErrorMessage';

const PlaybackErrorMessage = () =>
  <T>{t =>
    <GetPeersPlaybackControl>{(control) => {
      if (!control) return;

      const { state, resume } = control;

      let message;
      let buttonLabel;

      switch (state) {
        case PlaybackState.Blocked:
          message = t('rtc.playback.blocked');
          buttonLabel = t('rtc.playback.play');
          break;
        case PlaybackState.PlayingWithBlockedSound:
          message = t('rtc.playback.muted');
          buttonLabel = t('rtc.playback.unmute');
          break;
      }

      if (message) {
        return (
          <CallErrorMessage buttonAction={resume} buttonLabel={buttonLabel}>
            {message}
          </CallErrorMessage>
        );
      } else {
        return null;
      }
    }}</GetPeersPlaybackControl>
  }</T>;

export default PlaybackErrorMessage;
